import { AppStateType } from 'reducers';

export const selectFilterReducer = (state: AppStateType) => state.filterReducer;
